import * as React from "react";
import { useSelector } from "react-redux";

import { Button, Card, Grid, Menu, Segment, Tab } from "semantic-ui-react";

import { Detail } from "@neworbit/simpleui-detail";

import { Authorize } from "reauthorize";

import { routeIdSelector } from "../selectors";
import { AccessGroupDetailModel } from "../models";
import { AccessGroupApi } from "../accessGroupsApi";

import { ADMIN_ROLES } from "../../auth";

import { EditModal } from "./EditModal";

import { Link } from "redux-little-router";

export const Details: React.FunctionComponent = () => {
    const accessGroupId = useSelector(routeIdSelector);
    const [showEditModal, setShowEditModal] = React.useState<boolean>(false);

    const [accessGroup, setAccessGroup] = React.useState<AccessGroupDetailModel | undefined>(undefined);

    const openEditModal = React.useCallback(() => setShowEditModal(true), []);
    const closeEditModal = React.useCallback(() => setShowEditModal(false), []);

    React.useEffect(() => {
        const getAccessGroup = async () => {
            const accessGroupData = await AccessGroupApi.get(accessGroupId);
            setAccessGroup(accessGroupData);
        };

        if (accessGroup === undefined)
        {
            getAccessGroup();
        }
    }, [accessGroup, accessGroupId]);

    if (!accessGroup)
    {
        return null;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column>
                        <h1>{accessGroup.name}</h1>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={3} as={Grid} padded>
                        <Grid.Column vertical as={Menu}>
                            <Menu.Item name="AdminUsers" as={Link} href="/accessGroups">
                                All Access Groups
                            </Menu.Item>
                        </Grid.Column>
                    </Grid.Column>

                    <Grid.Column width={13}>
                        <Card fluid>
                            <Tab.Pane>
                                <Grid>
                                    <Detail label="Name" value={accessGroup.name} labelWidth={5} valueWidth={11} />
                                    <Detail label="Object ID" value={accessGroup.id} labelWidth={5} valueWidth={11} />
                                    <Detail
                                        label="Customers"
                                        value={accessGroup.customers.map(customer => customer.name).join(", ")}
                                        labelWidth={5}
                                        valueWidth={11}
                                    />
                                    <Detail label="Active" value={accessGroup.active ? "Yes" : "No"} labelWidth={5} valueWidth={11} />
                                </Grid>
                            </Tab.Pane>
                        </Card>
                        <Segment basic clearing vertical>
                            <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                                <Button icon="pencil" content="Edit" floated="right" onClick={openEditModal} />
                            </Authorize>
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <EditModal accessGroup={accessGroup} open={showEditModal} closeModal={closeEditModal} updateAccessGroup={setAccessGroup} />
        </>
    );
};
